module.exports = __webpack_public_path__ + "img/404.c555cae2.png";